import React from 'react';
import {useNavigate} from 'react-router-dom';

interface ClickableTableCellProps {
    cell: any;
    urlGenerator: (rowData: any) => string | null;
}

const ClickableTableCell: React.FC<ClickableTableCellProps> = ({
    cell,
    urlGenerator
}) => {
    const navigate = useNavigate();
    const rowData = cell.row.original;

    const url = urlGenerator(rowData);
    const value = cell.getValue();

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        if (url) {
            navigate(url);
        }
    };

    return url ? (
        <a href={url} onClick={handleClick} className="text-decoration-none">
            {value}
        </a>
    ) : (
        <span>{value}</span>
    );
};

export default ClickableTableCell;
